var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.api.token == null)?_c('LoginScreen'):_vm._e(),(this.api.token == null)?_c('RegisterScreen'):_vm._e(),(this.api.token != null && _vm.currentPage == 'GameScreen')?_c('GameScreen'):_vm._e(),(_vm.currentPage == 'ShopScreen')?_c('ShopScreen'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }